import React from 'react';
import { DefaultconversionListFormData } from '.';
import useBrandChefsContext from 'contexts/brand-chefs.context';
import { Input } from '@cokitchen/cokitchen-components';

const AddConversionListDetails = () => {
  const { conversionListFormData, setConversionListFormData } = useBrandChefsContext();
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | { target: { name: string; value: string } },
    index: number
  ) => {
    const { name, value } = e.target;
    setConversionListFormData(
      conversionListFormData.map((itm, i) => (i === index ? { ...itm, [name]: value } : itm))
    );
  };

  const addVendor = () => {
    setConversionListFormData([...conversionListFormData, { ...DefaultconversionListFormData }]);
  };
  const removeVendor = (index: number) => {
    setConversionListFormData(conversionListFormData.filter((item, i) => index !== i));
  };

  return (
    <div>
      <h3 className='text-xl font-semibold'>Add new item</h3>
      {conversionListFormData?.map((item, index) => (
        <div key={index}>
          <div className='gap-6 w-[100%] mt-8'>
            <Input
              design='bordered'
              name='secton_name'
              label='Section name'
              value={item.secton_name}
              onChange={(e) => handleChange(e, index)}
              placeholder='Section name'
            />

            <Input
              design='bordered'
              name='name'
              label='Prepped item'
              value={item.name}
              onChange={(e) => handleChange(e, index)}
              placeholder='Item name'
            />
          </div>
          <div className='flex justify-end'>
            {index >= 1 && (
              <button
                onClick={() => removeVendor(index)}
                className='text-[#E60A2B] mt-2 font-medium text-sm '>
                - Remove Item
              </button>
            )}
          </div>
        </div>
      ))}
      <button onClick={addVendor} className='text-[#0080E5] mt-2 font-medium text-sm'>
        + Add Item
      </button>
    </div>
  );
};

export default AddConversionListDetails;
